"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFullName = exports.validateUrl = exports.validateLength = exports.validateEmail = void 0;
const WEBSITE_PATTERN = /^(www\.)[a-zA-Z0-9 |.-/]+\.[a-zA-Z| /]+(\/[a-zA-Z0-9#]+\/?)*$/;
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,50}$/;
// regexp pattern email validator
const validateEmail = (data) => {
    return EMAIL_PATTERN.test(data);
};
exports.validateEmail = validateEmail;
// string length validation by equation types
const validateLength = (data, length, equationType = '=') => {
    let valid;
    switch (equationType) {
        case '=':
            valid = data.trim().length === length;
            break;
        case '<':
            valid = data.trim().length < length;
            break;
        case '>':
            valid = data.trim().length > length;
            break;
        default:
            valid = false;
    }
    return valid;
};
exports.validateLength = validateLength;
// regexp pattern url validator
const validateUrl = (data) => {
    return WEBSITE_PATTERN.test(data);
};
exports.validateUrl = validateUrl;
// check if user has set up both name and surname
const validateFullName = (data) => {
    var _a;
    const splitted = data.split(' ').filter(el => el !== '');
    const l = splitted[1] && splitted[1].length > 1 ? (_a = splitted[1]) === null || _a === void 0 ? void 0 : _a.trim() : true;
    return !(!l || (splitted === null || splitted === void 0 ? void 0 : splitted.length) < 2 || data.replace(/\s/g, '').length < 4);
};
exports.validateFullName = validateFullName;
